// Split book titles written as "Title - Author (Year)" into their parts.
//
// Ghost has no custom fields, so book notes carry author and year in the
// post title by convention. Anything marked data-book-title gets its text
// rebuilt as spans so the theme can set title, author and year separately.
// Without JavaScript, the title simply shows as written.
export default function bookTitles() {
    const pattern = /^(.+?)\s+[-–—]\s+(.+?)(?:\s*\((\d{4})\))?\s*$/;

    document.querySelectorAll("[data-book-title]").forEach((el) => {
        const match = el.textContent.trim().match(pattern);
        if (!match) return;

        const [, title, author, year] = match;
        el.textContent = "";

        const name = document.createElement("span");
        name.className = "book-name";
        name.textContent = title;
        el.appendChild(name);

        const by = document.createElement("span");
        by.className = "book-author";
        by.textContent = author;
        el.appendChild(by);

        if (year) {
            const when = document.createElement("span");
            when.className = "book-year";
            when.textContent = year;
            el.appendChild(when);
        }
    });
}
